import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import { DeviationResourceType } from '../../../types/deviation';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';

import s from './SubscribeToUnlockTooltip.scss';
import { BiData, ViewSubscriptionTabBiEvent } from '@wix/da-bi/pkg/events';

const TOOLTIP_WIDTH = 144;

export interface Props {
  deviation: PapiDeviation;
  children: React.ReactNode;
  forceVisible?: boolean;
  className?: string;
}

const SubscribeToUnlockTooltip: React.FC<Props> = ({
  deviation,
  children,
  forceVisible,
  className,
}) => {
  const { t } = useTranslation();
  const {
    tier,
    isTier,
    isOwner,
    isUserSubscribed,
    subscriptionsTabUrl,
    needsSubscription,
    isSubscribedButBlocked,
  } = useSubscriptionTier(deviation);

  const isSubscribedTier = isTier && !isOwner && isUserSubscribed;
  const isInASubscribedTier = !isTier && !needsSubscription && !isSubscribedButBlocked;
  if (isSubscribedTier || isInASubscribedTier || !tier?.author) {
    return <>{children}</>;
  }

  const description = isSubscribedButBlocked
    ? t('deviation.tier.subscribersOnly.tooltip.lockedSubscribed')
    : t('deviation.tier.subscribersOnly.tooltip.unsubbed');
  return (
    <SophisticatedTooltip
      className={className}
      size="large"
      width={TOOLTIP_WIDTH}
      placement="top"
      aria-label={description}
      description={description}
      isVisible={forceVisible ? true : undefined}
      postfix={
        <SophisticatedTooltipLink
          href={subscriptionsTabUrl}
          className={s['subs-link']}
          biData={BiData<ViewSubscriptionTabBiEvent>({
            evid: 547,
            referral_info: ReferralType.ACTION_BAR,
            typeid: DeviationResourceType.TIER,
            itemid: tier?.deviationId,
          })}
        >
          {t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink')}
        </SophisticatedTooltipLink>
      }
    >
      {children}
    </SophisticatedTooltip>
  );
};
SubscribeToUnlockTooltip.displayName = 'SubscribeToUnlockTooltip';
export default SubscribeToUnlockTooltip;
